<div class="p-6">

  <div class="flex flex-wrap items-center justify-between gap-4">
    <h1 class="font-bold text-3xl">Applications</h1>
    <div class="flex flex-wrap items-center gap-2">
      <p-button
        label="Delete selected"
        icon="pi pi-trash"
        severity="danger"
        (onClick)="deleteSelectedApplications()"
        [loading]="isDeletingApplications()"
        [disabled]="isDeletingApplications() || selectedApplications.length === 0"
        class="p-button-sm"
      ></p-button>
      <p-button
        label="Reapply to all failed lotteries"
        icon="pi pi-refresh"
        (onClick)="retryFailedApplications()"
        [loading]="isRetryingFailedApplications()"
        [disabled]="isRetryingFailedApplications()"
        class="p-button-sm"
      ></p-button>
    </div>
  </div>

  @let applications = applications$ | async;

  <h2 class="font-medium text-2xl">Failed applications</h2>
  @if (applications) {
    <p-table [value]="applications" [(selection)]="selectedApplications" dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox />
          </th>
          <th>User ID</th>
          <th>Lottery</th>
          <th>Failure reason</th>
          <th>Created at</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-application [cTypedTableRow]="applications">
        <tr>
          <td (click)="$event.stopPropagation()">
            <p-tableCheckbox [value]="application" />
          </td>
          <td class="cursor-pointer" [routerLink]="['/users', application.userId]">{{ application.userId }}</td>
          <td class="cursor-pointer" [routerLink]="['/users', application.userId]">{{ application.lotteryId }}</td>
          <td class="cursor-pointer" [routerLink]="['/users', application.userId]">{{ application.failureReason }}</td>
          <td class="cursor-pointer" [routerLink]="['/users', application.userId]">
            {{ application.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
